import React, { useMemo } from 'react'; // Agregamos useMemo
import { Grid2 } from "@mui/material";
import { LinkItem } from "../../../components/model/cardAdministradorModel"
import CardAdministrador from "../../../components/ui/materialui/cardAdministrador";
import { AttachMoney, Handshake, FileCopy} from "@mui/icons-material";
import { usePermissions } from '../../../components/auth/ProtectedRoute'; // Hook de permisos
import { TipoFuncionalidad } from '../../../utils/enums'; // Tus Enums

const AdministracionEndosos: React.FC = () => {
    const { hasPermission } = usePermissions();

    const linksPermitidos = useMemo<LinkItem[]>(() => {
        const todosLosLinks = [
            { 
                to: "/endosos/endosos-masivos", 
                icon: <Handshake sx={{ fontSize: 22, color: "#ACD35E" }} />, 
                text: "Endosos masivos",
                permission: TipoFuncionalidad.Endoso_masivo 
            },
            { 
                to: "/endosos/archivo-endosos-psm", 
                icon: <FileCopy sx={{ fontSize: 22, color: "#ACD35E" }} />, 
                text: "Archivo endoso PMS",
                permission: TipoFuncionalidad.Endoso_masivo 
            },
            { 
                to: "/endosos/endosos-psm", 
                icon: <AttachMoney sx={{ fontSize: 22, color: "#ACD35E" }} />, 
                text: "Recaudación de endosos masivos",
                permission: TipoFuncionalidad.Endoso_masivo 
            },
        ];

        return todosLosLinks.filter(link => hasPermission(link.permission));
    }, [hasPermission]);

    if (linksPermitidos.length === 0) return null;

    return (
        <div>
            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                    <CardAdministrador
                        title="Endosos masivos"
                        icon={<Handshake sx={{ fontSize: 20, color: "white" }} />}
                        links={linksPermitidos} 
                        backgroundColor="#ACD35E"
                        linkTextColor="text-info"
                    />
                </Grid2>
            </Grid2 >
        </div>
    )
}

export default AdministracionEndosos;